<template>
  <div v-if="product && productPrice">
    <define-title-template>
      <h1 v-if="!isElevated" :class="brandClasses.headingProductName" data-test-id="product-name">
        {{ product.name }}
      </h1>
    </define-title-template>
    <define-eyebrow-template>
      <template v-if="product.eyebrow">
        <vf-toggletip v-if="product.eyebrow.details">
          <template #trigger>
            <span class="flex gap-1 items-center">
              <p v-bind="eyebrowStyle" class="eyebrow line-clamp-1">
                {{ product.eyebrow.label }}
              </p>
              <vf-icon name="info" />
            </span>
          </template>
          {{ product.eyebrow.details }}
        </vf-toggletip>
        <p v-else-if="product.eyebrow.label" v-bind="eyebrowStyle" class="eyebrow line-clamp-1">
          {{ product.eyebrow.label }}
        </p>
      </template>
    </define-eyebrow-template>
    <div :class="brandClasses.headingWrapper">
      <template v-if="$feature.showBadgeAboveTitle">
        <title-template />
        <eyebrow-template />
      </template>
      <template v-else>
        <eyebrow-template />
        <title-template />
      </template>
      <p v-if="product.promoExclusionsMessage" :class="brandClasses.headingExclusions">
        {{ product.promoExclusionsMessage }}
      </p>
      <product-reviews-summary v-if="!isElevated" :reviews-data="reviewsData" />
    </div>
    <product-pricing
      :class="brandClasses.headingProductPricing"
      :currency="product.currency"
      :price="productPrice"
      :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      :show-original-price-for-omnibus="$feature.showOmnibusBadgeOnQuickshopAndPDP"
    >
      <template #append>
        <vf-tooltip v-if="salesPriceActiveDate" class="-ml-2" :class="pricingBrandClasses.sale">
          <template #trigger>
            <vf-icon name="info" />
          </template>
          {{ replaceAll($t.salesPriceActiveDateInfo, { date: formattedSalesDate }) }}
        </vf-tooltip>
      </template>
    </product-pricing>
  </div>
</template>

<script lang="ts" setup>
import { formatDate } from '@vueuse/core'

const { eyebrowStyle, product, productPrice, reviewsData } = usePdp()
const { brandClasses } = useAppConfig().pages.pdp
const { brandClasses: pricingBrandClasses } = useAppConfig().components.product.pricing

const [DefineTitleTemplate, TitleTemplate] = createReusableTemplate()
const [DefineEyebrowTemplate, EyebrowTemplate] = createReusableTemplate()

const isElevated = computed(() => product.value?.elevatedPDPDetails?.enable)

const salesPriceActiveDate = computed(() =>
  product.value && getDefaultColorOption(product.value.attributes, product.value.id).price?.salesPriceActiveDate)

const formattedSalesDate = computed(() => salesPriceActiveDate.value ? formatDate(new Date(salesPriceActiveDate.value), 'MM/DD') : '')
</script>
